export const RESET_PASSWORD_ERROR_118 = '118';
